module.exports = __webpack_public_path__ + "img/advance7_2.51dc960e.png";